import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';
import { getConfig } from '../configuracao/configLocal';

export function getLog(agrupador = 0) {
  return dispatch => {
    const controladorId = getConfig('cont');
    
    // Se não há controlador selecionado, retorna lista vazia
    if (!controladorId || controladorId === 0) {
      dispatch({
        type: 'LOG_ADAPTATIVO_FETCHED',
        payload: { data: [] },
      });
      return;
    }

    dispatch({ type: 'LOG_ADAPTATIVO_LOADING' });

    // Adicionar parâmetro de agrupamento na requisição
    const params = agrupador > 0 ? { agrupador } : {};

    const request = axiosInstance.get(`/adaptativo/tabela/${controladorId}`, { params })
      .then(response => {
        // A API retorna os dados na propriedade 'dados'
        // Os dados já vêm com data e hora formatados do backend
        let data = response.data && Array.isArray(response.data.dados) ? response.data.dados : [];
        
        // Validar e limpar dados que possam ter campos inválidos
        data = data.filter(item => {
          if (!item || !item.data || !item.hora) {
            console.warn('Registro com dados inválidos removido:', item);
            return false;
          }
          return true;
        });
        
        dispatch({
          type: 'LOG_ADAPTATIVO_FETCHED',
          payload: { data },
        });
      })
      .catch(error => {
        console.error('Erro ao buscar logs adaptativos:', error);
        toastr.error('Erro', 'Falha ao carregar os dados dos logs adaptativos');
        
        dispatch({
          type: 'LOG_ADAPTATIVO_ERROR',
          payload: error.message || 'Erro ao carregar dados',
        });
      });
  };
} 